import { buildHubAsync } from "./signalR.js";

function logConnectionEvents(connection, eventName) {
	connection.on(eventName, () => console.log(`SignalR Event: ${eventName}`));
}
// Public
export async function buildConferenceQueueHubAsync(hubConfig, notarizationId) {
	const connection = await buildHubAsync(window.Notary.Config.Hubs.ConferenceQueue, hubConfig, notarizationId);

	if (hubConfig.debugLog) {
		logConnectionEvents(connection, `SystemOnlineUntil`);
		logConnectionEvents(connection, `QueueToggle`);
		logConnectionEvents(connection, `WaitTime`);
		logConnectionEvents(connection, `LawDepotPing`);
		logConnectionEvents(connection, `LawDepotPingBack`);
		logConnectionEvents(connection, `NotaryPing`);
		logConnectionEvents(connection, `NotaryAccept`);
		logConnectionEvents(connection, `LawDepotDisconnected`);
		logConnectionEvents(connection, `NotaryAccept`);
		logConnectionEvents(connection, `LawDepotAccept`);
		logConnectionEvents(connection, `LawDepotDeny`);
		logConnectionEvents(connection, `TimedOut`);
		logConnectionEvents(connection, `LeaveToCall`);
		logConnectionEvents(connection, `StatusUpdated`);
	}

	if (hubConfig.onSystemOnlineUntil) {
		connection.on(`SystemOnlineUntil`, hubConfig.onSystemOnlineUntil);
	}
	if (hubConfig.onQueueToggle) {
		connection.on(`QueueToggle`, hubConfig.onQueueToggle);
	}
	if (hubConfig.onWaitTime) {
		connection.on(`WaitTime`, hubConfig.onWaitTime);
	}
	if (hubConfig.onLawDepotPing) {
		connection.on(`LawDepotPing`, hubConfig.onLawDepotPing);
	}
	if (hubConfig.onLawDepotPingBack) {
		connection.on(`LawDepotPingBack`, hubConfig.onLawDepotPingBack);
	}
	if (hubConfig.onNotaryPing) {
		connection.on(`NotaryPing`, hubConfig.onNotaryPing);
	}
	if (hubConfig.onLawDepotDisconnected) {
		connection.on(`LawDepotDisconnected`, hubConfig.onLawDepotDisconnected);
	}
	if (hubConfig.onNotaryAccept) {
		connection.on(`NotaryAccept`, hubConfig.onNotaryAccept);
	}
	if (hubConfig.onLawDepotAccept) {
		connection.on(`LawDepotAccept`, hubConfig.onLawDepotAccept);
	}
	if (hubConfig.onLawDepotDeny) {
		connection.on(`LawDepotDeny`, hubConfig.onLawDepotDeny);
	}
	if (hubConfig.onTimedOut) {
		connection.on(`TimedOut`, hubConfig.onTimedOut);
	}
	if (hubConfig.onLeftToCall) {
		connection.on(`LeaveToCall`, hubConfig.onLeftToCall);
	}
	if (hubConfig.onStatusUpdated) {
		connection.on(`StatusUpdated`, hubConfig.onStatusUpdated);
	}

	return connection;
}
